import { render, staticRenderFns } from "./addSupplierCoupon.vue?vue&type=template&id=e6f0e0a0"
import script from "./addSupplierCoupon.vue?vue&type=script&lang=js"
export * from "./addSupplierCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports